import { makeStyles } from '@material-ui/core';
import {
	BOGLE_MEDIUM,
	BOGLE_REGULAR,
	INLINE_BLOCK,
} from '../../constants/constant';
import { colors } from '../../theme/color-palette';

const { FONT_COLOR, PURPLE } = colors;

export const styles = {
	title: {
		fontSize: '24px !important',
		color: FONT_COLOR,
		display: INLINE_BLOCK,
		fontFamily: BOGLE_REGULAR,
	},
	content: {
		marginTop: '8px !important',
		fontSize: '16px !important',
		color: FONT_COLOR,
		fontFamily: BOGLE_REGULAR,
	},
	inTransitTitle: {
		fontSize: 20,
		color: FONT_COLOR,
		display: INLINE_BLOCK,
		fontFamily: BOGLE_REGULAR,
	},
	inTransitContent: {
		marginTop: '4px',
		fontSize: 14,
		color: FONT_COLOR,
		fontFamily: BOGLE_REGULAR,
	},
	closeButton: {
		display: INLINE_BLOCK,
		marginTop: '-6px',
		marginRight: '8px',
		float: 'right',
	},
	cbTitle: {
		fontSize: 20,
		color: PURPLE,
		display: INLINE_BLOCK,
		fontFamily: BOGLE_REGULAR,
		marginBottom: '4px',
	},
	cbSubTitle: {
		fontSize: 14,
		fontWeight: '500',
		color: FONT_COLOR,
		fontFamily: BOGLE_MEDIUM,
	},
	cbSubContent: {
		fontSize: 14,
		color: FONT_COLOR,
		fontFamily: BOGLE_REGULAR,
		marginBottom: '16px',
	},
};

const blockMarginStyles = {
	marginLeft: 16,
	marginRight: 16,
};

export const useStyles = makeStyles(() => ({
	container: {
		width: '360px',
	},
	header: {
		marginTop: 16,
		marginLeft: 16,
	},
	contentBlockStyle1: {
		...blockMarginStyles,
		marginTop: 32,
	},
	contentBlockStyle2: {
		...blockMarginStyles,
		marginTop: 16,
	},
	contentBlockStyle3: {
		...blockMarginStyles,
		marginTop: 32,
		marginBottom: 10,
	},
	divider: {
		marginTop: 16,
	},
}));
